import { Component } from 'react';
import Header from '../../Header';
import MessageLink from '../../MessageLink';
import Footer from '../../Footer';
import Lgpd from '../../Lgpd';

import FiltroNoticia from '../../Filtros/FiltroNoticias';
import ErrorBoundary from '../../ErrorHandler/ErrorBoundary';
import InfoComponent from '../InfoComponent';
class Area extends Component {

	render() {

		return (


			<div>
				{/* HEADER */}{/* LOGIN */}
				<ErrorBoundary><Header /></ErrorBoundary>

				<InfoComponent image={"noticias"} page={'noticias'}></InfoComponent>		
			
				{/* <div className="_the-content page-noticias pt-10 mb-8"> */}
				<ErrorBoundary><FiltroNoticia /></ErrorBoundary>

				{/* </div> */}

				{/* Content page */}
				{/*  <ScrollInfinito/> */}
				{/* FOOTER */}
				<ErrorBoundary><Footer /></ErrorBoundary>
				{/* Message Link */}
				<ErrorBoundary><MessageLink /></ErrorBoundary>
				{/* LGPD */}
				<ErrorBoundary><Lgpd /></ErrorBoundary>
			</div>
		);
	}
};

export default Area;